/* Shared item-key updates, gift detection, and merchandise totals.
   v38: the free bronze pendant is added by EG Auto Add to Cart and made free by its own app
   discount ("Free Bronze Pendant"), which targets the exact line EG tagged with _Gifted.
   The theme no longer applies a gift code, and each cart write uses the cart Shopify returns
   instead of reading it again, so a change is one request instead of up to seven. */
(function(root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    const config = JSON.parse(root.document.getElementById('ch-cart-config').textContent);
    root.CHCartState = api.create(async (path, payload) => {
      const response = await root.fetch(config.root + path, {
        method: payload ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: {'Accept': 'application/json', ...(payload ? {'Content-Type': 'application/json'} : {})},
        ...(payload ? {body: JSON.stringify(payload)} : {})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Your cart could not be updated. Please try again.');
      return data;
    }, config);
  }
})(typeof window !== 'undefined' ? window : null, function() {
  // A gift is any line EG added (it carries the _Gifted property).
  const isGift = item => !!(item.properties && (item.properties._Gifted || item.properties._ch_bonus));
  const codes = cart => (cart.discount_codes || []).filter(d => d.applicable).map(d => d.code);
  const uniqueCodes = values => [...new Map(values.filter(Boolean).map(c => [c.toLowerCase(), c])).values()];
  function totals(cart) {
    const original = (cart.items || []).reduce((n, i) => n + i.original_line_price, 0);
    const lines = (cart.items || []).reduce((n, i) => n + i.final_line_price, 0);
    const orderDiscounts = (cart.cart_level_discount_applications || [])
      .filter(d => d.target_type !== 'shipping_line')
      .reduce((n, d) => n + (Number(d.total_allocated_amount) || 0), 0);
    const subtotal = Math.max(0, lines - orderDiscounts);
    return {subtotal, savings: Math.max(0, original - subtotal)};
  }
  function create(request) {
    let queue = Promise.resolve();
    const enqueue = job => { const next = queue.then(job); queue = next.catch(() => {}); return next; };
    const get = () => request('cart.js');
    // cart/change.js and cart/update.js both return the full cart.
    const write = (path, body) => request(path, body);
    return {
      totals, isGift,
      refresh: () => enqueue(get),
      // Unknown keys make cart/change.js return an error, so a stale drawer can't change the wrong line.
      change: (key, quantity) => enqueue(() => write('cart/change.js', {id: key, quantity})),
      update: (updates, note) => enqueue(() => write('cart/update.js', {updates, ...(note !== undefined ? {note} : {})})),
      discount: code => enqueue(async () => {
        const before = await get();
        const previous = codes(before);
        let cart = await write('cart/update.js', {discount: uniqueCodes([...previous, code]).join(',')});
        const valid = codes(cart).some(c => c.toLowerCase() === code.toLowerCase());
        // A code that doesn't combine with product discounts can knock out the free gift; keep the gift free.
        const freeGiftKeys = before.items.filter(i => isGift(i) && i.final_line_price === 0).map(i => i.key);
        const giftCharged = cart.items.some(i => freeGiftKeys.includes(i.key) && i.final_line_price > 0);
        if (!valid || giftCharged) {
          cart = await write('cart/update.js', {discount: previous.join(',')});
          return {cart, valid: false};
        }
        return {cart, valid};
      }),
      removeDiscount: () => enqueue(() => write('cart/update.js', {discount: ''}))
    };
  }
  return {create, totals, isGift};
});
